import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import CurrentOrdersViewModal from "../modals/order-view-modals/currentOrdersViewModal";
import UpdateStatusModal from "../modals/updateStatusModal";
import UploadInvoiceTableModal from "../modals/uploadInvoiceTableModal";
import CurrentOrdersPdfView from "../modals/order-view-modals/currentOrdersPdfView";
import UpArrow from "../../../src/assets/up-arrow.png";
import DownArrow from "../../../src/assets/down-arrow.png";
import "./currentOrders.css";
import {
  fetchOrderRemarksList,
  supplyOrderCfa,
  updateOrderStatus,
} from "../../redux/actions/orderActions";
import SuccessPopup from "../Popups/SuccessPopUp";
import ErrorPopup from "../Popups/ErrorPopup";

const CurrentOrderTableData = ({
  data,
  index,
  fetchOrderList,
  currentPage,
  remarksList,
}) => {
  const [showDetail, setShowDetail] = useState(false);
  const [selectedOrder, setOrderSelected] = useState(null);
  const [showUploadInvoiceModal, setShowUploadInvoiceModal] = useState(false);
  const [openRemark, setOpenRemark] = useState(false);
  const [activeRemark, setActiveRemark] = useState(null);
  const [selectedRemark, setselectedRemark] = useState(null);
  const [selectedRemarkDesc, setSelectedRemarkDesc] = useState(null);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const dispatch = useDispatch();
  const componentRef = useRef(null);

  const handleClickOutside = (event) => {
    if (componentRef.current && !componentRef.current.contains(event.target)) {
      setOpenRemark(false);
    }
  };

  useEffect(() => {
    if (openRemark) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [openRemark]);

  const UpdateRemarkFnc = () => {
    if (selectedRemark !== null) {
      dispatch(
        updateOrderStatus(
          {
            order_id: data.id,
            reason_for_rejection_id: selectedRemark,
            description: selectedRemarkDesc,
          },
          onSuccess,
          onError
        )
      );
    }
  };

  const onSuccess = (data) => {
    console.log(data);
    fetchOrderList();
    setOpenRemark(false);
  };
  const onError = (err) => {};

  const palceOrderToCFA = () => {
    dispatch(
      supplyOrderCfa(
        {
          order_id: data.id,
        },
        onPlaceOrderSuccess,
        onPlaceOrderError
      )
    );
  };

  const timeOutFnc = () => {
    setShowSuccessPopup(false);
    fetchOrderList();
  };

  const onPlaceOrderSuccess = (data) => {
    console.log(data);
    setShowSuccessPopup(true);
    const message = data.data.message;
    const msg_updated = message.charAt(0).toUpperCase() + message.slice(1);
    setShowSuccessMsg(msg_updated);
    setTimeout(timeOutFnc, 2000);
  };
  const onPlaceOrderError = (err) => {
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };
  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  return (
    <tr className="table-rows1" key={data.id}>
      <td className="main-table-each-row-data">{index + 1}</td>
      <td className="main-table-each-row-data">{data.order_id}</td>
      <td className="main-table-each-row-data">
        {moment(data.createdAt).format("DD MMM YYYY, HH:mm A").toUpperCase()}
      </td>
      <td className="main-table-each-row-data">{data?.doctor?.name}</td>
      <td className="main-table-each-row-data">
        {data?.pharmacy_id
          ? data?.pharmacy?.pharmacy_name
          : data?.doctor?.pharmacy_type === "attach"
          ? data?.doctor?.doctorAttachPharmacy?.pharmacy?.pharmacy_name
          : data?.doctor?.pharmacy_type === "self"
          ? data?.doctor?.doctorSelfPharmacy?.pharmacy_name
          : data?.doctor?.pharmacy_type === "dispensing" && "Dispensing"}
      </td>
      <td className="main-table-each-row-data">{data?.vendor?.name}</td>
      <td className="main-table-each-row-data">{data?.vendorDivision?.name}</td>
      <td className="main-table-each-row-data">
        {data?.city?.name ? data?.city?.name : "--"}
      </td>
      <td className="main-table-each-row-data">₹ {data?.total}</td>

      <td className="main-table-each-row-data">
        <span
          className={`${
            orderStatus.find((e) => e?.status == data?.status)?.color
          }`}
        >
          {orderStatus.find((e) => e?.status == data?.status)?.value}
        </span>
      </td>
      <td
        className="main-table-each-row-data position-relative"
        ref={componentRef}
      >
        <>
          <div onClick={() => setOpenRemark(!openRemark)}>
            <span className="mx-1 color_747f9e">select</span>
            {openRemark ? (
              <img src={UpArrow} className="mb-1 mx-1" />
            ) : (
              <img src={DownArrow} className=" mx-1" />
            )}
          </div>

          {openRemark && (
            <div className="position-absolute remarks-container">
              <div className="m-3">
                <div className="Medium_Purple fw_600 fs_16">Order Remarks</div>
                <div
                  className="cursor_pointer"
                  style={{ height: "150px", overflow: "scroll" }}
                >
                  {remarksList?.map((item, index) => (
                    <div
                      onClick={() => {
                        setActiveRemark(index);
                        setselectedRemark(item.value);
                        setSelectedRemarkDesc(item.label);
                      }}
                      className={
                        activeRemark == index
                          ? "active-remark w-100 p-2 "
                          : "w-100 p-2"
                      }
                    >
                      {item.label}
                    </div>
                  ))}
                </div>
                <div className="text-end my-3">
                  <label
                    onClick={() => setOpenRemark(false)}
                    className="mx-2  fs_16 Medium_Purple fw_600"
                  >
                    CANCEL
                  </label>
                  <label
                    className="mx-2  text-danger fs_16 fw_600"
                    onClick={() => UpdateRemarkFnc()}
                  >
                    REJECT
                  </label>
                </div>
              </div>
            </div>
          )}
        </>
        {/* )} */}
      </td>
      <td className="main-table-each-row-data d-flex align-items-center">
        <span
          className="color_2ad3e7 fw_700 cursor_pointer"
          onClick={() => {
            setOrderSelected(data?.id);
            setShowDetail(true);
          }}
        >
          VIEW
        </span>
        <span className="vr_line mx-1 ms-2 color_b0b3c7"></span>
        <button
          className="Medium_Purple fw_600 cursor_pointer action-btn"
          disabled={
            data?.placed_to_cfa === true ||
            data?.status !== "approved" ||
            data?.vendorDivision?.reimbursement_method !== "forward_cfa"
          }
          onClick={() => {
            palceOrderToCFA();
          }}
        >
          SUPPLY FROM CFA
        </button>
        <span className="vr_line mx-1 color_b0b3c7 "></span>

        <span
          className="text-danger fw_700 mx-1  text-nowrap cursor_pointer"
          onClick={() => {
            setOrderSelected(data?.id);
            setShowUploadInvoiceModal(true);
          }}
        >
          UPLOAD INVOICE
        </span>
      </td>
      <td>
        <CurrentOrdersViewModal
          ordersViewShow={showDetail}
          showClose={() => setShowDetail(false)}
          id={selectedOrder}
        />

        <UploadInvoiceTableModal
          handleClose={() => setShowUploadInvoiceModal(false)}
          show={showUploadInvoiceModal}
          id={selectedOrder}
          fetchOrderList={fetchOrderList}
        />
        <SuccessPopup show={showSuccessPopup} title={showSuccessMsg} />
        <ErrorPopup
          show={showErrorPopup}
          title={showErrorMsg}
          handleClose={closeErrorPopup}
        />
      </td>
    </tr>
  );
};

export default CurrentOrderTableData;

export const orderStatus = [
  { status: "pending", value: "Approval Pending", color: "text-warning" },
  { status: "approved", value: "Approved", color: "color_2ad3e7" },
  { status: "fully_invoiced", value: "Fully Invoiced", color: "text_green" },
  {
    status: "partially_invoiced",
    value: "Partially Invoiced",
    color: "Medium_Purple",
  },
  { status: "rejected", value: "Rejected", color: "text-danger" },
  { status: "approval_failed", value: "Approval Failed", color: "text-danger" },
  { status: "cancelled", value: "Cancelled", color: "text-danger" },
  { status: "expired", value: "Expired", color: "text-danger" },
  { status: "acknowledged", value: "Acknowledged", color: "ack_status" },
  {
    status: "partially_acknowledged",
    value: "Partially acknowledged",
    color: "Medium_Purple",
  },
  { status: "hold", value: "Hold", color: "text-danger" },
];
